import { Model } from '@app/shared/models/model.interface';
import { PaymentMethod, PaymentProvider } from './payment.provider.model';

export class PaymentConfigurationModel implements Model {
  public paymentProvider: PaymentProvider | null;
  public paymentMethods: Array<PaymentMethod>;
  public isEnabled: boolean;
  public publicToken: string;

  /**
   * Constructor to initialize the properties
   * - Make sure the properties are initialized (to avoid unexpected undefined values)
   * @constructor
   */
  constructor() {
    this.paymentProvider = null;
    this.paymentMethods = [];
    this.isEnabled = false;
    this.publicToken = '';
  }

  /**
   * Helper function to sanitize the data that comes from the Backend.
   * @param data The Raw JSON Object
   * @returns {PaymentConfigurationModel} An instance of the payment configuration class.
   */
  public static fromJson(
    data?: Record<string, any> | null
  ): PaymentConfigurationModel | null {
    let paymentConfiguration: PaymentConfigurationModel | null = null;
    if (data) {
      paymentConfiguration = new PaymentConfigurationModel();
      paymentConfiguration.paymentProvider =
        data.paymentProvider || data.payment_provider || null;
      paymentConfiguration.paymentMethods =
        data.paymentMethods || data.payment_methods || [];
      paymentConfiguration.isEnabled = data.isEnabled || data.is_enabled || false;
      paymentConfiguration.publicToken = data.publicToken || data.public_token || '';

      // for the ranked payment methods
      if (data.payment_method) {
        paymentConfiguration.paymentMethods = data.payment_method || [];
      }
    }
    return paymentConfiguration;
  }

  /**
   * Helper function to sanitize the data that comes from the Backend.
   * @param data The Raw JSON Object
   * @returns {Array<PaymentConfigurationModel>} An Array of Delivery Info instances.
   */
  public static fromJsonArray(
    data?: Array<Record<string, any>>
  ): Array<PaymentConfigurationModel> | null {
    const paymentConfigurations: Array<PaymentConfigurationModel> = new Array(0);

    if (data && data.length > 0) {
      for (const configData of data) {
        const info: PaymentConfigurationModel | null =
          PaymentConfigurationModel.fromJson(configData);
        if (info) {
          paymentConfigurations?.push(info);
        }
      }
    }

    return paymentConfigurations;
  }
}
